import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutHamburgerMenuBar } from 'components/layout/LayoutHamburgerMenuBar';
export function Todo() {
    return (_jsx(LayoutHamburgerMenuBar, { children: _jsx("div", { children: "To Do" }) }));
}
